import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import { useNavigate, useLocation } from 'react-router-dom';
import './Header.css';

interface HeaderProps {
  title: string;
}

const Header: React.FC<HeaderProps> = ({ title }) => {
  const { logout } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    await logout();
  };

  const handleNavigation = (path: string) => {
    navigate(path);
  };

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  const getPageTitle = () => {
    switch (location.pathname) {
      case '/users':
        return 'Пользователи';
      case '/chats':
        return 'Чаты';
      case '/news':
        return 'Новости';
      case '/application':
        return 'Приложение';
      default:
        return 'Панель управления';
    }
  };

  return (
    <header className="admin-header">
      <h1>{getPageTitle()}</h1>
      <div className="header-navigation">
        <div className="nav-tabs">
          <button 
            className={`nav-tab ${isActive('/') ? 'active' : ''}`}
            onClick={() => handleNavigation('/')}
          >
            Главная
          </button>
          <button 
            className={`nav-tab ${isActive('/users') ? 'active' : ''}`}
            onClick={() => handleNavigation('/users')}
          >
            Пользователи
          </button>
          <button 
            className={`nav-tab ${isActive('/chats') ? 'active' : ''}`}
            onClick={() => handleNavigation('/chats')}
          >
            Чаты
          </button>
          <button 
            className={`nav-tab ${isActive('/news') ? 'active' : ''}`}
            onClick={() => handleNavigation('/news')}
          >
            Новости
          </button>
          <button 
            className={`nav-tab ${isActive('/application') ? 'active' : ''}`}
            onClick={() => handleNavigation('/application')}
          >
            Приложение
          </button>
        </div>
        <button 
          className="theme-toggle-btn" 
          onClick={toggleTheme}
          title={theme === 'dark' ? 'Переключить на светлую тему' : 'Переключить на темную тему'}
        >
          {theme === 'dark' ? '☀️' : '🌙'}
        </button>
        <button className="logout-btn" onClick={handleLogout}>
          Выйти
        </button>
      </div>
    </header>
  );
};

export default Header;
